export enum GlobalActionType {
  CLEAR_STORE = 'CLEAR_STORE',
}

export const {
    CLEAR_STORE
} = GlobalActionType;

export interface GlobalAction {
  type: GlobalActionType
  payload?: any
  meta?: {
    redirect: boolean
    path: string
  }
}

export const HIDDEN_OPTIONS = ['app_foil_die', 'design', 'print_border'];
